import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeAccount } from './home-account/home-account.component';
import { AuthGuard } from '../shared/auth-guard';
const routes: Routes = [
	{ path: 'homeaccount', component: HomeAccount, canActivate: [AuthGuard] }
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule],
	providers: []
})
export class AccountRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/account/account-routing.ts